/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RescheduleAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function RescheduleAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/NextAppointment/Content/Content/Content/AppointmentOptions/RescheduleAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<AppointmentAction
  viewPath={`${viewPath}/AppointmentAction`}
 text="Reschedule"
 onClick={onClick}
/>
{children}
</React.Fragment>)
}